import { Locale } from 'src/types'

import { FuelType } from 'src/pages/FuelTracking/enums'

export function getDictionaryFuelType(
  locale: Locale['trackFuel']['addInfoFuel'],
): Record<FuelType, string> {
  const { diesel, gas, petrol95, petrol92, petrol98, petrol100, electric } =
    locale

  return {
    [FuelType.DIESEL]: diesel,
    [FuelType.GAS]: gas,
    [FuelType.Electricity]: electric,
    [FuelType.PETROL95]: petrol95,
    [FuelType.PETROL92]: petrol92,
    [FuelType.PETROL98]: petrol98,
    [FuelType.PETROL100]: petrol100,
  }
}
